import { Button, EmptyState } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import type { OutpatientClinicTaskListFilter } from '../types/outpatientClinicTaskListFilter';
import { emptyOutpatientClinicTaskListFilter } from '../constants/emptyOutpatientClinicTaskListFilter';

export type OutpatientClinicTaskListNoResultsProps = {
    setFilter: (filter: OutpatientClinicTaskListFilter) => void;
};

export function OutpatientClinicTaskListNoResults({ setFilter }: OutpatientClinicTaskListNoResultsProps) {
    const translate = getSelectedLanguage();

    return (
        <EmptyState
            icon="searchresults"
            subtitle={translate.contactsAndTasks.noResultsPatientTaskListSubtitle}
            title={translate.contactsAndTasks.noResultsPatientTaskListTitle}
            variant="centered"
        >
            <Button
                color="secondary"
                onClick={() => {
                    setFilter(emptyOutpatientClinicTaskListFilter);
                }}
                variant="outline"
            >
                {translate.common.deleteSearchTerms}
            </Button>
        </EmptyState>
    );
}
